module.exports = __webpack_public_path__ + "media/images/icons/icon-progress-fe4fc71adc285b4fa2d240c3d25a5a6d.svg";